import { graphql } from '@api/mesa'

export const GET_WAITLIST_STATUS = graphql(`
  query getWaitlistStatus {
    getWaitlistStatus {
      isWaitlisted
    }
  }
`)

export const GET_CREDIT_CARD_INFORMATION = graphql(`
  query GetCreditCardInformation {
    getCreditCardInformation {
      node {
        id
        last4
        status
        virtualCardIdForPhysicalCard
        physicalCardTrackingNumber
        financialAccount {
          id
          name
          accountStatus
          creditOutstanding
          availableCredit
          accountHodlerCreditLimit
          outstandingBalancePayable
          currentAmountDue
          statementPaymentDueOn
          statementBalance
          statementMinimumPayment
          statementPeriodEnd
          statementPeriodStart
          paymentCardAPR
          paymentCardCreditLine
          paymentCardNextClosingDate
        }
      }
    }
  }
`)

export const GET_CARD_ORDER_INFORMATION = graphql(`
  query GetCardOrderInformation {
    getCardOrderInformation {
      node {
        id
        status
        trackingNumber
      }
    }
  }
`)

export const GENERATE_DOCUMENT_UPLOAD_CLIENT_TOKEN = graphql(`
  query GenerateDocumentUploadClientToken {
    generateDocumentUploadClientToken {
      result {
        __typename
        ... on HighnoteDocumentUploadClientTokenSuccess {
          clientTokenValue
          documentUploadSessionId
        }
        ... on HighnoteDocumentUploadClientTokenUnavailable {
          message
        }
        ... on MesaUserError {
          message
        }
      }
    }
  }
`)

export const GET_LINKED_EXTERNAL_ACCOUNTS = graphql(`
  query getLinkedExternalBankAccounts($products: [Products!]) {
    getLinkedExternalBankAccounts(products: $products) {
      accounts {
        highnoteExternalAccountId
        plaidAccountId
        last4
        bankName
        accountName
        accountSubtype
        isVerified
        status
        products
      }
    }
  }
`)

export const GET_STATEMENTS = graphql(`
  query getStatements {
    getStatements {
      statementId
      statementDate
    }
  }
`)
